import api from './client'
import type { Language } from '@/types/language'

export function fetchLanguages() {
  return api.get<{ data: Language[] }>('/languages')
}

export function fetchLanguage(id: number) {
  return api.get<{ data: Language }>(`/languages/${id}`)
}

export function createLanguage(data: { iso_code: string; name: string; description: string }) {
  return api.post<{ data: Language }>('/languages', { language: data })
}

export function updateLanguage(id: number, data: { iso_code: string; name: string; description: string }) {
  return api.patch<{ data: Language }>(`/languages/${id}`, { language: data })
}

export function enrollInLanguage(languageId: number) {
  return api.post('/enrollments', { language_id: languageId })
}

export function unenrollFromLanguage(languageId: number) {
  return api.delete(`/enrollments/${languageId}`)
}
